const theme = {
  colors: {
    bgColor: "#ffffff",
    linkColor: "#666",
    titleColor: "#42446E",
    projectTitleColor: "#000",
    lightColor: "#A7A7A7",
    hover: "#4b0266",
  },
  fontSize: {
    bigText: "5.8rem",
    sectionTitle: "4.2rem",
    sectionSubTitle: "3.2rem",
    projectTitle: "2.8rem",
    link: "1.6rem",
    projectText: "1.8rem",
    smallText: "1.6rem",
  },
};

export default theme;
